import React from 'react';

import {
	MAX_NOTIFICATIONS_COUNT,
	PUSH_NOTIFICATION_CLICK,
	TEST_IDS,
} from '@/constants';
import { sendClickEvent } from '@/utils/AnalyticsUtils';
import { Button } from '@/widgets';
import { BellIcon } from '@/assets/icons';

import styles from './NotificationBell.module.scss';

interface INotificationBellProps {
	unreadNotificationCount: number;
	onBellClick: () => void;
}

export default function NotificationBell({
	unreadNotificationCount,
	onBellClick,
}: INotificationBellProps) {
	return (
		<Button
			onClick={() => {
				onBellClick();
				sendClickEvent({
					name: PUSH_NOTIFICATION_CLICK,
					additionalData: {
						notificationCount: unreadNotificationCount,
					},
				});
			}}
			className={styles.notificationButton}
			variant="text"
			data-id={TEST_IDS.NOTIFICATION_ICON}
		>
			<BellIcon width={22} height={22} />
			{unreadNotificationCount > 0 ? (
				<span className={styles.redDot}>
					{unreadNotificationCount > MAX_NOTIFICATIONS_COUNT
						? `${MAX_NOTIFICATIONS_COUNT}+`
						: unreadNotificationCount}
				</span>
			) : null}
		</Button>
	);
}
